<ul class="options-wrapper">
  <li class="option" *ngFor="let option of options" [class.selected]="option.value">
    <mat-checkbox [checked]="option.value" [disabled]="option.disabled" (change)="onSelectionChanged(option.name, $event)"> {{ option?.translation ?? option.name | bmsTranslate }}</mat-checkbox>
  </li>
</ul>
